<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center">
              <img src="https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_200/site/logo" alt="ICS Logo">
            </v-flex>
            <v-flex xs12 md10 offset-md1>
              <p class="subheading">The shape of the logo is circle, it has a major circle in the middle w/ binary numbers as the backdrop on top of it,there are 6 circles inside with figures showing the different areas of technology. The dominant color in the logo is green which denotes the color of the institute. Green signifies the advancement of the institute in the field of computer science. In the center of the logo there’s a power button image that signifies the power of the institute.</p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/About/Seal.vue